import { atom } from 'jotai'

/**
 * 配送種別マスタのインポートModalの表示状態
 */
export const isOpenShipmentCategoryImportModalAtom = atom<boolean>(false)

isOpenShipmentCategoryImportModalAtom.debugLabel =
  'isOpenShipmentCategoryImportModalAtom'
